import React, {useEffect} from "react";

import SectionContainerComponent from "@Components/Sections/SectionContainer";
import {Row, Col} from "react-bootstrap";

import Logo from "@Assets/Logo.png";

import "./index.scss";
import {NavLink} from "react-router-dom";
import {ButtonComponent} from "@Components/Forms/Buttons";
import starIcon from "@Icons/SVG/icon-star.svg";
import ApplicationHeaderLogo from "./Logo";
import ApplicationHeaderMotto from "./Motto";

import { GiHamburgerMenu } from "react-icons/gi";
import {UseQyvoUser} from "@Store/@Hooks";
import ApplicationHeaderUserZoneComponent from "@Parts/@Header/@User";


type ApplicationHeaderProps = {};


export const ApplicationHeader:React.FC<ApplicationHeaderProps> = () => {


    const QyvoUser = UseQyvoUser();


    const [menuOpenStatus, setMenuOpenStatus] = React.useState(false);

    useEffect(() => {
        return () => {
            setMenuOpenStatus(false);
        };
    }, []);


    return (
        <SectionContainerComponent id={'app-header'} as={'header'} extraClassName={QyvoUser ? 'logged-qyvo-user' : ''}>

            <ApplicationHeaderLogo />

            <ApplicationHeaderMotto />

            {/*{QyvoUser &&*/}
            {/*<ApplicationHeaderUserZoneComponent />*/}
            {/*}*/}


            {/*{!QyvoUser && (<>*/}
            {/*<Col as={'nav'} xs={2} lg={'auto'} className={'app-header__service-navigation'}>*/}

            {/*    <Row className={'app-header__service-navigation__hamburger-button'}>*/}
            {/*        <span className={'app-header__service-navigation__hamburger-button__element'} onClick={() => setMenuOpenStatus(!menuOpenStatus)}>*/}
            {/*            <GiHamburgerMenu />*/}
            {/*        </span>*/}
            {/*    </Row>*/}

            {/*    <Row className={'app-header__service-navigation__nav_menu' + (menuOpenStatus ? ' mobile-menu-opened' : '')}>*/}
            {/*        <Col xs={'auto'} className={'app-header__service-navigation__nav_menu__element'}>*/}
            {/*            <ButtonComponent*/}
            {/*                type={'flat'}*/}
            {/*                text={'How it works'}*/}
            {/*                href={'/how-it-works'}*/}
            {/*            />*/}
            {/*        </Col>*/}
            {/*        <Col xs={'auto'} className={'app-header__service-navigation__nav_menu__element'}>*/}
            {/*            <ButtonComponent*/}
            {/*                type={'flat'}*/}
            {/*                text={'Security'}*/}
            {/*                href={'/security'}*/}
            {/*            />*/}
            {/*        </Col>*/}
            {/*        <Col xs={'auto'} className={'app-header__service-navigation__nav_menu__element'}>*/}
            {/*            <ButtonComponent*/}
            {/*                type={'flat'}*/}
            {/*                text={'FAQ'}*/}
            {/*                href={'/faq'}*/}
            {/*            />*/}
            {/*        </Col>*/}
            {/*        <Col xs={'auto'} className={'app-header__service-navigation__nav_menu__element'}>*/}
            {/*            <ButtonComponent*/}
            {/*                type={'flat'}*/}
            {/*                text={'Contact'}*/}
            {/*                href={'/contact-us'}*/}
            {/*            />*/}
            {/*        </Col>*/}
            {/*    </Row>*/}

            {/*</Col>*/}


            {/*</>)}*/}

            {/*<Col xs={{ span: 6, offset: 3 }} lg={{ span: 2, offset: 6 }} className={'app-header__join-qyvo-cta'}>*/}
            {/*    <ButtonComponent*/}
            {/*        text={'Get early access'}*/}
            {/*        href={'https://useqyvo.com/join-qyvo'}*/}
            {/*        size={'l'}*/}
            {/*        type={'cta'}*/}
            {/*        iconLeft={starIcon}*/}
            {/*    />*/}
            {/*</Col>*/}
        </SectionContainerComponent>
    );

};


export default ApplicationHeader;
